
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/svg-icon",
      function () {
        return require("private-next-pages/joy-ui/api/svg-icon.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/svg-icon"])
      });
    }
  